<template lang="pug">
NuxtLayout
    Html(translate='no')
    UApp
        NuxtLoadingIndicator
        ClientOnly
            UButton.rounded-none(
                v-if="needRefresh"
                @click="updateServiceWorker()"
                variant="solid"
                color="primary"
                label="Update Available"
                block
                size="sm"
            )
        NuxtPage
</template>
<script setup lang="ts">
import { onMessage } from 'firebase/messaging'

//provideHeadlessUseId(() => useId());
// useHead({
//     script: [
//         { src: '/newrelic.js', defer: true }
//     ]
// });
const { $fcm } = useNuxtApp()
const toast = useToast()
onMounted(() => {
    onMessage($fcm.messaging, payload => {
        $fcm.store.messages.unshift(payload)
        toast.add({
            title: payload.notification?.title,
            description: payload.notification?.body,
        })
        if (process.env.NODE_ENV === 'development') {
            console.log('Message received on app:. ', payload)
        }
    })
})

const needRefresh = ref(false)
const updateServiceWorker = async () => {
    if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration()
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' })
            try {
                window.location.reload()
            } catch (e) {
                location.reload()
            }
        }
    }
}
onMounted(() => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            window.location.reload()
            needRefresh.value = true
        })
    }
})
</script>
